<template>
  <div
    class="relative flex min-h-0 flex-1 flex-col overflow-hidden bg-gradient-to-b from-stone-50 via-stone-100 to-amber-50/40 dark:from-[#08060c] dark:via-[#050308] dark:to-[#0c0a12]"
  >
    <SiteTopBar />
    <div
      class="pointer-events-none absolute inset-0 z-0 bg-gradient-to-br from-white/40 via-transparent to-amber-100/25 dark:from-[#1a1522]/30 dark:via-transparent dark:to-[#120e1a]/50"
      aria-hidden="true"
    />
    <div
      class="relative z-[1] flex flex-1 items-center justify-center px-4 pb-10 pt-below-site-topbar min-[480px]:px-8"
    >
      <div
        class="w-full max-w-[420px] rounded-3xl border border-stone-200/90 bg-white/75 p-8 shadow-[0_24px_80px_-12px_rgba(28,25,23,0.18)] backdrop-blur-xl min-[480px]:p-10 dark:border-white/[0.08] dark:bg-[rgba(12,10,18,0.72)] dark:shadow-[0_28px_90px_-16px_rgba(0,0,0,0.65)]"
      >
        <div class="flex flex-col items-center text-center">
          <h1
            class="m-0 text-[clamp(1.5rem,4.5vw,1.85rem)] font-semibold tracking-tight text-stone-900 dark:text-[#f4ebe0]"
          >
            Shabash Panel
          </h1>
        </div>

        <form class="mt-8 flex w-full flex-col gap-5" @submit.prevent="onSubmit">
          <div
            v-if="formError"
            role="alert"
            class="rounded-xl border border-red-200/90 bg-red-50/95 px-3.5 py-2.5 text-center text-sm text-red-800 dark:border-red-500/25 dark:bg-red-950/40 dark:text-red-200/95"
          >
            {{ formError }}
          </div>
          <div class="flex flex-col gap-2">
            <label class="text-sm font-medium text-stone-700 dark:text-stone-300" for="user">{{
              $t('login.email')
            }}</label>
            <input
              id="user"
              v-model.trim="email"
              type="text"
              autocomplete="email"
              class="min-h-12 w-full rounded-xl border border-stone-200/95 bg-white/90 px-4 py-3 text-base text-stone-900 shadow-sm outline-none transition-[border-color,box-shadow] placeholder:text-stone-400 focus:border-amber-500/70 focus:ring-2 focus:ring-amber-500/25 dark:border-white/10 dark:bg-white/[0.06] dark:text-[#f4ebe0] dark:placeholder:text-stone-500/55 dark:focus:border-[rgba(242,216,150,0.45)] dark:focus:ring-[rgba(242,216,150,0.15)]"
              :placeholder="$t('login.emailPh')"
            />
          </div>
          <div class="flex flex-col gap-2">
            <label class="text-sm font-medium text-stone-700 dark:text-stone-300" for="pass">{{
              $t('login.password')
            }}</label>
            <input
              id="pass"
              v-model="password"
              type="password"
              autocomplete="current-password"
              class="min-h-12 w-full rounded-xl border border-stone-200/95 bg-white/90 px-4 py-3 text-base text-stone-900 shadow-sm outline-none transition-[border-color,box-shadow] placeholder:text-stone-400 focus:border-amber-500/70 focus:ring-2 focus:ring-amber-500/25 dark:border-white/10 dark:bg-white/[0.06] dark:text-[#f4ebe0] dark:placeholder:text-stone-500/55 dark:focus:border-[rgba(242,216,150,0.45)] dark:focus:ring-[rgba(242,216,150,0.15)]"
              :placeholder="$t('login.passwordPh')"
            />
          </div>
          <button
            class="mt-1 flex min-h-12 w-full cursor-pointer items-center justify-center rounded-xl bg-gradient-to-r from-amber-800 to-amber-700 px-4 py-3 text-sm font-semibold text-white shadow-md shadow-amber-900/20 outline-none disabled:cursor-wait disabled:opacity-65 dark:from-amber-700 dark:to-amber-600 dark:shadow-black/40"
            type="submit"
            :disabled="loading"
          >
            {{ loading ? '…' : $t('login.submit') }}
          </button>
          <!-- <button
            type="button"
            class="flex h-10 min-w-10 cursor-pointer items-center justify-center rounded-xl border border-stone-200/90 bg-white/90 text-stone-800 hover:border-amber-500/45 hover:text-amber-900 dark:border-white/10 dark:bg-white/[0.06] dark:text-[#dfc06e] dark:hover:border-[rgba(242,216,150,0.4)] dark:hover:text-[#f2d896]"
          >
          <img src="/google-logo.svg" alt="" width="32" height="32" loading="lazy" decoding="async" />
          </button> -->
        </form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

definePageMeta({
  middleware: 'guest'
})

const { t } = useI18n()
const route = useRoute()

const email = ref('')
const password = ref('')
const loading = ref(false)
const formError = ref('')

async function onSubmit() {
  formError.value = ''
  loading.value = true
  try {
    const { ok, data } = await apiJson('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email: email.value, password: password.value })
    })
    const d = data as { error?: string }
    if (ok) {
      const redir = typeof route.query.redirect === 'string' ? route.query.redirect : '/'
      await navigateTo(redir.startsWith('/') ? redir : '/', { replace: true })
      return
    }
    formError.value =
      d?.error === 'server_misconfigured' ? t('login.misconfigured') : t('login.error')
  } catch {
    formError.value = t('login.network')
  } finally {
    loading.value = false
  }
}
</script>
